<template lang="pug">
div
  v-card.border.rounded-lg.pa-6(outlined min-height="100vh")
    v-row(dense align="center")
      v-col(cols="5")
        div.text-sm.font-semibold.neutral700--text Activities
      v-col(cols="7")
        y-select(v-model="type" small placeholder="Select campaign" attach :items="types" item-text="text" item-value="value" @change="fetchActivities")
    div.mt-3
      div.d-flex.justify-center.mt-16(v-if="isFetching")
        v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        div.py-3(v-for="activity in activities")
          template(v-if="setting.loyalty_system === 'stamps'")
            div.text-xs.neutral700--text
              span.font-medium.mr-1 {{ activity.member.name }}
              span(v-if="activity.type === 'rewards'") redeemed a reward
              span(v-else) collected {{ activity.collect_value === 1 ? 'a' : activity.collect_value }} stamp. {{ activity.balance < 10 ? `${10 - activity.balance} more to go` : 'All stamps have been collected'}}
            div.d-flex.align-center.mt-2
              v-avatar.mr-2(size="3" color="blue500")
              div.text-xs.neutral500--text {{ activity.created | convertToHumanizeTime }}

          template(v-if="setting.loyalty_system === 'points'")
            div.text-xs.neutral700--text
              span.font-medium.mr-1 {{ activity.member.name }}
              span(v-if="activity.type === 'rewards'") redeemed a reward
              span(v-else) collected {{ activity.collect_value }} pts.
            div.d-flex.align-center.mt-2
              v-avatar.mr-2(size="3" color="blue500")
              div.text-xs.neutral500--text {{ activity.created | convertToHumanizeTime }}

        div.py-3(v-if="!activities.length")
          div.text-xs.neutral500--text.font-medium.text-center.mt-6 No data

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      isFetching: false,
      type: null,
      activities: []
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      setting: 'marketing/getMarketingSettings'
    }),
    types () {
      let types = []
      if (this.setting.loyalty_system === 'stamps') {
        types = [
          { text: 'Stamp only', value: 'stamps' },
          { text: 'Reward only', value: 'rewards' },
          { text: 'Stamp & reward', value: 'stamps,rewards' },
        ]
      } else if (this.setting.loyalty_system === 'points') {
        types = [
          { text: 'Point only', value: 'points' },
          { text: 'Reward only', value: 'rewards' },
          { text: 'Point & reward', value: 'points,rewards' },
        ]
      }
      return types
    }
  },
  mounted () {
    if (this.setting.loyalty_system === 'stamps') {
      this.type = 'stamps,rewards'
    } else if (this.setting.loyalty_system === 'points') {
      this.type = 'points,rewards'
    }
    this.fetchActivities()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchActivities () {
      this.isFetching = true
      let params = {
        types: this.type,
      }
      this.$axios.get(`/loyalty/${this.company.slug}/activities`, { params })
        .then(resp => {
          this.activities = resp.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>